import PropTypes from 'prop-types';
import React, { useId } from 'react';

const SapLogo = (props) => {
    const {
        hideTitle,
        ...otherProps
    } = props;

    const gradientSuffix = useId();
    const idSuffix = useId();

    return (
        <svg
            id={`Sap_logo_${idSuffix}`}
            data-test="Sap_logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 82 40"
            role={hideTitle ? 'presentation' : 'img'}
            {...otherProps}
        >
            {!hideTitle && <title>SAP</title>}
            <defs>
                <linearGradient id={`SAP-${gradientSuffix}`} x1="40.26" y1="0" x2="40.26" y2="39.83" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#00b8f1" />
                    <stop offset=".02" stopColor="#00b5ef" />
                    <stop offset=".31" stopColor="#0d90d8" />
                    <stop offset=".58" stopColor="#1675c8" />
                    <stop offset=".82" stopColor="#1c64be" />
                    <stop offset="1" stopColor="#1e5fbb" />
                </linearGradient>
            </defs>
            <polyline style={{ fill: `url(#SAP-${gradientSuffix})`, fillRule: 'evenodd' }} points="0 39.83 40.69 39.83 80.52 0 0 0 0 39.83" />
            <path style={{ fill: '#fff', fillRule: 'evenodd' }} d="m47.78,7.49h-7.92s0,18.84,0,18.84l-6.92-18.84h-6.86l-5.91,15.76c-.63-3.97-4.74-5.35-7.97-6.37-2.14-.69-4.4-1.69-4.38-2.81.02-.92,1.22-1.77,3.59-1.64,1.6.08,3,.21,5.8,1.56l2.75-4.79c-2.56-1.3-6.09-2.12-8.98-2.12h-.02c-3.37,0-6.18,1.09-7.93,2.89-1.21,1.26-1.87,2.86-1.9,4.62-.04,2.43.85,4.16,2.72,5.53,1.58,1.16,3.61,1.91,5.39,2.47,2.2.68,4,1.27,3.98,2.54-.02.46-.19.89-.52,1.24-.55.57-1.39.78-2.55.8-2.24.05-3.91-.3-6.56-1.87l-2.45,4.86c2.64,1.51,5.78,2.39,8.97,2.39h.41c2.78-.06,5.03-.85,6.82-2.29.1-.08.2-.17.29-.25l-.8,2.12h7.2l1.21-3.67c1.26.43,2.7.67,4.23.67s2.89-.23,4.13-.63l1.16,3.64h11.74v-7.61h2.56c6.19,0,9.85-3.15,9.85-8.44,0-5.88-3.56-8.59-11.13-8.59Zm-18.32,16.12c-.92,0-1.79-.16-2.54-.44l2.51-7.93h.05l2.47,7.95c-.74.26-1.59.42-2.49.42Zm18.78-4.55h-1.75v-6.39h1.75c2.33,0,4.18.77,4.18,3.15s-1.86,3.24-4.18,3.24" />
        </svg>
    );
};

SapLogo.displayName = 'SapLogo';

SapLogo.propTypes = {
    hideTitle: PropTypes.bool,
};

export default SapLogo;
